import React from 'react';

const Skills = () => {
  return (
    <div className="skills">
      <div className="list">
        <div className="skill">
          <i className="devicon-javascript-plain colored" />
        </div>
        <div className="skill">
          <i className="devicon-nodejs-plain-wordmark colored" />
        </div>
        <div className="skill">
          <i className="devicon-express-original-wordmark" />
        </div>
        <div className="skill">
          <i className="devicon-mongodb-plain-wordmark colored" />
        </div>
        <div className="skill">
          <i className="devicon-babel-plain colored" />
        </div>
        <div className="skill">
          <i className="devicon-webpack-plain-wordmark colored" />
        </div>
        <div className="skill">
          <i className="devicon-html5-plain-wordmark colored" />
        </div>
        <div className="skill">
          <i className="devicon-css3-plain-wordmark colored" />
        </div>
        <div className="skill">
          <i className="devicon-git-plain-wordmark colored" />
        </div>
        <div className="skill">
          <i className="devicon-github-plain colored" />
        </div>
        <div className="skill">
          <i className="devicon-jquery-plain-wordmark colored" />
        </div>
        <div className="skill">
          <i className="devicon-visualstudio-plain-wordmark colored" />
        </div>
        <div className="skill">
          <i className="devicon-typescript-plain colored" />
        </div>
        <div className="skill">
          <i className="devicon-d3js-plain" />
        </div>
      </div>
    </div>
  );
};

export default Skills;
